import { isDevelopmentEnvironment } from '../../utils/common'
import { ICON_CHEVRON_DIRECTION } from '../Icon'

import {
  GRETA_AI_CHAT_PROJECT_META_SEPARATOR,
  GretaAIChatPanelView,
  GretaAIChatProjectSubjectType,
} from './GretaAIChat.constants'

function getGretaAIChatProjectBuildingName(building, t) {
  return building.hasAccess
    ? building.address
    : t('Greta.ProjectScopeBuildingNumberKey', { number: building.number })
}

function getIsGretaAIChatProjectAboutBuilding(subject) {
  return subject?.type === GretaAIChatProjectSubjectType.Building
}

function getIsGretaAIChatProjectAboutRequests(subject) {
  return subject?.type === GretaAIChatProjectSubjectType.Requests
}

export function getIsGretaAIChatProjectsEnabled() {
  return isDevelopmentEnvironment()
}

export function getIsGretaAIChatProjectsView(view) {
  return view === GretaAIChatPanelView.Projects
}

export function getGretaAIChatProjectScopeLabel(subject, t) {
  if (getIsGretaAIChatProjectAboutBuilding(subject)) {
    return subject.building.hasAccess
      ? t('Greta.ProjectScopeBuildingKey', {
          address: subject.building.address,
        })
      : getGretaAIChatProjectBuildingName(subject.building, t)
  }

  if (getIsGretaAIChatProjectAboutRequests(subject)) {
    const [firstRequest] = subject.requests
    const requestsLabel = t('Greta.ProjectScopeRequestsKey', {
      count: subject.requests.length,
      number: firstRequest.number,
    })

    return [
      requestsLabel,
      getGretaAIChatProjectBuildingName(subject.building, t),
    ].join(GRETA_AI_CHAT_PROJECT_META_SEPARATOR)
  }

  return t('Greta.ProjectScopeEmptyKey')
}

export function getGretaAIChatExpandChevronDirection(isExpanded) {
  return isExpanded ? ICON_CHEVRON_DIRECTION.DOWN : ICON_CHEVRON_DIRECTION.RIGHT
}

export function getHasGretaAIChatProjects(projects) {
  return projects.length > 0
}

export function getHasGretaAIChatProjectChats(projectChats) {
  return projectChats.length > 0
}

export function getHasGretaAIChatProjectChat(projectChats, chatId) {
  return projectChats.some(chat => chat.id === chatId)
}

export function getGretaAIChatProjectChatIds(projects) {
  return new Set(projects.flatMap(project => project.chatIds))
}
